// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_j-1";
export var movingGradient = "_j-4";
export var movingGradientBlock = "_j-2";
export var skeleton = "_j-0";
export var skeletonText = "_j-3";